<template>
  <div>
    <!--page header section start-->
    <section class="page-header position-relative overflow-hidden ptb-120 child-phone-section text-white">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <h1 class="display-5 fw-bold text-white text-start">Frequently Asked Questions</h1>
                    <p class="lead text-start">Find answers to common questions and get the help you need!</p>
                </div>
            </div>
            <!--<div class="bg-circle rounded-circle circle-shape-3 position-absolute bg-dark-light right-5"></div>-->
        </div>
    </section>
    <!--page header section end-->
    <section>
        <div class="container">
            <div class="row justify-content-center" style="padding: 60px 0 120px;">
                <div class="col-lg-9 col-12">
                    <div class="accordion faq-accordion text-start" id="accordionExample">
                        <div class="accordion-item border border-2 active">
                            <h5 class="accordion-header" id="faq-1">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="false">
                                    What is Kids Smartphone?
                                </button>
                            </h5>
                            <div id="collapse-1" class="accordion-collapse collapse" aria-labelledby="faq-1" data-bs-parent="#accordionExample" style="">
                                <div class="accordion-body">
                                    Kids Smartphone is a smartphone designed specifically for children, offering a secure and controlled introduction to the digital world. It addresses parents' concerns about the potential harmful effects of early smartphone exposure on children.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-2">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="false">
                                    How long does shipping take?
                                </button>
                            </h5>
                            <div id="collapse-2" class="accordion-collapse collapse" aria-labelledby="faq-2" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Average shipping time is 2-3 days. Shipping is free.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-3">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-3" aria-expanded="false">
                                    What operating system runs on Kids Smartphone?
                                </button>
                            </h5>
                            <div id="collapse-3" class="accordion-collapse collapse" aria-labelledby="faq-3" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Currently, only Android OS is supported. iOS support will be launched soon.
                                </div>
                            </div>
                        </div>
    
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-4">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-4" aria-expanded="false">
                                    What phone models are available for purchase?
                                </button>
                            </h5>
                            <div id="collapse-4" class="accordion-collapse collapse" aria-labelledby="faq-4" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    All available phone models are listed on our website. If you need a specific model that is not listed, you can request it from us or purchase it from the market and buy a Kids Smartphone subscription.
                                </div>
                            </div>
                        </div>
    
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-5">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-5" aria-expanded="false">
                                    Can I use my existing old Android phone as a Kids Smartphone?
                                </button>
                            </h5>
                            <div id="collapse-5" class="accordion-collapse collapse" aria-labelledby="faq-5" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Yes, you can use any older Android device running Android 11 or higher. Simply purchase a Kids Smartphone subscription, upon which you will receive a QR code.
                                    <h4>Steps:</h4>
                                    <ul>
                                        <li>Factory reset the old Android phone from Android settings</li>
                                        <li>On the very first screen, tap the screen 5 times to launch the camera application</li>
                                        <li>Scan the QR code that you received for your subscription</li>
                                        <li>Follow the setup process</li>
                                        <li>Once the Android configuration is complete, you'll find the Kids First app on your device. Please open the app and log in using the email address you provided during the payment process.</li>
                                        <li>Once the device is set up, please log in to the parental portal on our website using your email address and password to manage the kid's device</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
    
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-6">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-6" aria-expanded="false">
                                    Can kids have access to browsers or social media?
                                </button>
                            </h5>
                            <div id="collapse-6" class="accordion-collapse collapse" aria-labelledby="faq-6" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    There are no social media apps or browsers on the device. Parents can add required apps on a need basis from the parental portal.
                                </div>
                            </div>
                        </div>
    
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-7">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-7" aria-expanded="false">
                                    Does parental control function in offline mode?
                                </button>
                            </h5>
                            <div id="collapse-7" class="accordion-collapse collapse" aria-labelledby="faq-7" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Yes, parental controls such as screen time and restrictions will work in offline mode. Changes to the screen times will not be possible remotely via parental portals.
                                </div>
                            </div>
                        </div>
    
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-8">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-8" aria-expanded="false">
                                    How can I manage screen time?
                                </button>
                            </h5>
                            <div id="collapse-8" class="accordion-collapse collapse" aria-labelledby="faq-8" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Parents can log in to the parental portal on our website or use the parental app. Screen time options will be available to manage.
                                </div>
                            </div>
                        </div>
    
                        <div class="accordion-item border border-2">
                            <h5 class="accordion-header" id="faq-9">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-9" aria-expanded="false">
                                    Can I locate my child using the parental portal?
                                </button>
                            </h5>
                            <div id="collapse-9" class="accordion-collapse collapse" aria-labelledby="faq-9" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Yes, the last known location is displayed on the parental portal.
                                </div>
                            </div>
                        </div>
    
                    </div>
                </div>
                </div>
        </div>
    </section>
  </div>
</template>

<script>
import {useToast} from 'vue-toast-notification';
const $toast = useToast();



export default {
  name: 'FAQ',
  components: {
    
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  methods: {
  },
  beforeMount() {
  },
  created () {
  },
}
</script>
<style scoped>

</style>